/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : GeneralInfo.tsx
 *
 * Project Title : APM Settings Tool
 *
 * Description   : General Info main component
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422337
 *
 * @Date         : Dec 30,2021
 *
 * @Version      : Version 1.0
 *
 * By            :
 * On            :
 * Description   :
 *
 *
 ******************************************************************************/

import React, { FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GeneralInfoForm } from "./GeneralInfoForm";
import { selectToken } from "stores/AuthStore";
import {
  fetchLoggedInUserContactDetails,
  selectLoggedInUserContactDetailsLoader,
} from "stores/GeneralInfoStore";
import { selectSelectedApmRecordLoader } from "stores/ApmWorkFlowStore";
import { CommonLoader } from "components/CommonLoader";
import "./GeneralInfo.scss";

export const GeneralInfo: FC = () => {
  const dispatch = useDispatch();
  const userToken = useSelector(selectToken);
  const loggedInUserContactDetailsLoader = useSelector(
    selectLoggedInUserContactDetailsLoader
  );
  const selectedApmRecordLoader = useSelector(selectSelectedApmRecordLoader);
  useEffect(() => {
    dispatch(fetchLoggedInUserContactDetails());
    // eslint-disable-next-line
  }, [userToken]);

  return (
    <>
      <div className="general-info-wrapper">
        {loggedInUserContactDetailsLoader || selectedApmRecordLoader ? (
          <CommonLoader />
        ) : (
          <GeneralInfoForm />
        )}
      </div>
    </>
  );
};
